var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.device.online && _vm.device.first_activation && _vm.device.last_online)?_c('span',[_vm._v("\n    "+_vm._s(_vm._f("dayjs")(_vm.device.last_online,'DD.MM.YYYY, HH:mm'))+"\n    "+_vm._s(_vm.$t('timeOfDay'))+"\n  ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Device/DeviceLastOnline.vue?vue&type=template&id=6dcc47ac&
// module id = 2322
// module chunks = 5